// extracted by mini-css-extract-plugin
export default {"ctn":"otherScenes_ctn__Ha-EC","textBox":"otherScenes_textBox__G-t-U"};